import nft from "../assets/images/projects/website.png";


export const repositories = [
  {
    title: "ensWebsite",
    description: "Personal portfolio app to show my skills and experience.",
    cover: nft,
    technologies: ["react", "chakraUi"],
    url: "https://github.com/SouchonTheo/ensWebsite",
    live: "",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    stars: "0",
    fork: "0"
  }
];
